import { withAddGiftMessageProps } from 'viewModel/rwdBasket/AddGiftMessage/withAddGiftMessageProps';
import AddGiftMessage from 'components/AddGiftMessage/AddGiftMessage';

export default withAddGiftMessageProps(AddGiftMessage);
